export const formatReviewCount = (count: number): string => {
  if (count >= 2000) return '2000+';
  if (count >= 1500) return '1500+';
  if (count >= 1000) return '1000+';
  if (count >= 500) return '500+';
  if (count >= 300) return '300+';
  if (count >= 200) return '200+';
  if (count >= 100) return '100+';
  if (count >= 50) return '50+';
  if (count >= 20) return '20+';
  if (count >= 10) return '10+';
  return String(count);
};
